<!-- HM popover -->
<template>
  <span class="hm-popover">
    <b-button :id="id" class="px-1 py-0" type="button" variant="link">
      <span v-if="label" :class="labelClass">{{label}}</span>
      <i v-else :class="classIconButton"></i>
    </b-button>
    <b-popover :target="id" :placement="placement" :triggers="triggers">
      <div v-if="title" slot="title">
        <span :class="classIconTitle"></span>
        {{title}}
      </div>
      <div>
        <slot>
          <div class="hm-popover-content pb-3">{{content}}</div>
          <div v-for="(line, index) in contentList" :key="index">{{line}}</div>
        </slot>
      </div>
    </b-popover>
  </span>
</template>

<script>
export default {
  name: 'HMPopover',
  props: {
    id: {
      type: String,
      default: function () {
        return 'popover-id-' + this._uid;
      }
    },
    icon: {
      type: String,
      default: 'info'
    },
    label: {
      type: String,
      default: null
    },
    labelClass: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    content: {
      type: String,
      default: null
    },
    contentList: {
      type: Array,
      default: function () {
        return []
      }
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    triggers: {
      type: String,
      default: 'hover'
    }
  },
  data() {
    return {}
  },
  computed: {
    classIconButton() {
      return [
        `icon-${this.icon}`
      ]
    },
    classIconTitle() {
      return [
        `icon-${this.icon}`,
        'pr-2'
      ]
    }
  }
}
</script>

<style>
.hm-popover {
  width: 400px;
  max-width: none; /* Required for popovers wider than 276px (Bootstrap's max-width for popovers) */
}
.hm-popover-content {
  white-space: pre-wrap;
}
</style>